(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6397"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6397"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d8HMG", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $990dfc566758140d$export$6503ec6e8aabbaf; }, function (v) { return $990dfc566758140d$export$6503ec6e8aabbaf = v; });
var $990dfc566758140d$export$6503ec6e8aabbaf;
var $990dfc566758140d$export$f7ad0328861e2f03;
"use strict";
var $990dfc566758140d$var$mapping = new Map();
function $990dfc566758140d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$990dfc566758140d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $990dfc566758140d$var$resolve(id) {
    var resolved = $990dfc566758140d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$990dfc566758140d$export$6503ec6e8aabbaf = $990dfc566758140d$var$register;
$990dfc566758140d$export$f7ad0328861e2f03 = $990dfc566758140d$var$resolve;

});

parcelRegister("3VV9c", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2dd306457558c0ef$export$bdfd709ae4826697; }, function (v) { return $2dd306457558c0ef$export$bdfd709ae4826697 = v; });
var $2dd306457558c0ef$export$bdfd709ae4826697;
var $2dd306457558c0ef$export$c9e73fbda7da57b6;
var $2dd306457558c0ef$export$5a759dc7a1cfb72a;
"use strict";
var $2dd306457558c0ef$var$bundleURL = {};
function $2dd306457558c0ef$var$getBundleURLCached(id) {
    var value = $2dd306457558c0ef$var$bundleURL[id];
    if (!value) {
        value = $2dd306457558c0ef$var$getBundleURL();
        $2dd306457558c0ef$var$bundleURL[id] = value;
    }
    return value;
}
function $2dd306457558c0ef$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2dd306457558c0ef$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2dd306457558c0ef$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2dd306457558c0ef$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2dd306457558c0ef$export$bdfd709ae4826697 = $2dd306457558c0ef$var$getBundleURLCached;
$2dd306457558c0ef$export$c9e73fbda7da57b6 = $2dd306457558c0ef$var$getBaseURL;
$2dd306457558c0ef$export$5a759dc7a1cfb72a = $2dd306457558c0ef$var$getOrigin;

});

parcelRegister("bo64b", function(module, exports) {
document.querySelector(".btn.btn-hamburger").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.remove("hide");
});
document.querySelector(".btn.navigationDrawer--closeBtn").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.add("hide");
});
document.querySelectorAll('[data-element="navItem-expander"]').forEach((el)=>{
    el.querySelector(".navigationDrawer--navItemBtn").addEventListener("click", (e)=>{
        if (el.querySelector(".navigationDrawer--navItemExpanded").classList.contains("hide")) {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.remove("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "180deg";
        } else {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.add("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "0deg";
        }
    });
});

});

parcelRegister("dUzBg", function(module, exports) {
const $a20c1ec3db67aafa$var$btnTopNavigationEls = document.querySelectorAll(".btn.link-item");
const $a20c1ec3db67aafa$var$navigationMegaDropdownEl = document.querySelector(".navigationMegaDropdown");






const $a20c1ec3db67aafa$var$setValueDropDownNavigation = (keyElement)=>{
    const dropdownNavigation = {
        services: [
            {
                pageUrl: "intelligent-finance.html",
                logoSrc: new URL((parcelRequire("6sU4q"))),
                title: "Intelligent Finance Function"
            },
            {
                pageUrl: "manage-payroll.html",
                logoSrc: new URL((parcelRequire("lmZD2"))),
                title: "Managed Payroll"
            },
            {
                pageUrl: "consulting.html",
                logoSrc: new URL((parcelRequire("bGuJ6"))),
                title: "Consulting"
            }
        ],
        products: [
            {
                pageUrl: "people-management.html",
                logoSrc: new URL((parcelRequire("jWpUW"))),
                title: "People Management"
            },
            {
                pageUrl: "power-insight.html",
                logoSrc: new URL((parcelRequire("jweF3"))),
                title: "Power Insight"
            },
            {
                pageUrl: "all-product.html",
                logoSrc: new URL((parcelRequire("7mHfH"))),
                title: "All Product"
            }
        ]
    };
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn").forEach((el, index)=>index > 0 && el.remove());
    dropdownNavigation[keyElement].forEach((value)=>{
        const navigationMegaDropdownBtn = $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdownBtn").cloneNode(true);
        navigationMegaDropdownBtn.href = value.pageUrl;
        navigationMegaDropdownBtn.querySelector('[data-element="logoNavigation"]').src = value.logoSrc;
        navigationMegaDropdownBtn.querySelector('[data-element="titleNavigation"]').textContent = value.title;
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdown--inner").appendChild(navigationMegaDropdownBtn);
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn")[0].remove();
};
$a20c1ec3db67aafa$var$btnTopNavigationEls.forEach((el)=>{
    el.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
        $a20c1ec3db67aafa$var$setValueDropDownNavigation(el.getAttribute("data-element"));
    });
    el.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
});

});
parcelRegister("6sU4q", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "battery-charging.ba1b1745.webp";

});

parcelRegister("lmZD2", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "settings-02.d69d69bd.webp";

});

parcelRegister("bGuJ6", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "life-buoy.285e728c.webp";

});

parcelRegister("jWpUW", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "people.d532b8d6.webp";

});

parcelRegister("jweF3", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "grid.f0e29351.webp";

});

parcelRegister("7mHfH", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "box.2a34708a.webp";

});


parcelRegister("5iqNH", function(module, exports) {

var $8Ay3m = parcelRequire("8Ay3m");
const $3db36c35411957e8$var$testimonialCardParent = document.querySelector(".swiper-wrapper.testimonial-cards");
(0, $8Ay3m.default).forEach((testimonial)=>{
    const testimonialCardEl = document.querySelector('[data-element="testimonial-card-slider"]').cloneNode(true);
    testimonialCardEl.querySelector('[data-element="testimonial-people-name"]').textContent = testimonial.name;
    testimonialCardEl.querySelector('[data-element="testimonial-position"]').textContent = testimonial.position;
    testimonialCardEl.querySelector('[data-element="testimonial-text-all"]').innerHTML = testimonial.testimonyTextAll;
    testimonialCardEl.querySelector('[data-element="testimonial-text-less"]').innerHTML = testimonial.testimonyTextLess ?? testimonial.testimonyText;
    testimonialCardEl.querySelector('[data-element="testimonial-company-logo"]').src = testimonial.companyLogo;
    testimonialCardEl.querySelector('[data-element="testimonial-company-logo"]').parentElement.classList.add(testimonial.companyLogoClass);
    testimonialCardEl.querySelector('[data-element="testimonial-photo-small"]').srcset = testimonial.photo.mobile;
    testimonialCardEl.querySelector('[data-element="testimonial-photo-large"]').src = testimonial.photo.desktop;
    $3db36c35411957e8$var$testimonialCardParent.appendChild(testimonialCardEl);
});
document.querySelectorAll('[data-element="testimonial-card-slider"]')[0].remove();
document.querySelectorAll(".testimonial-content .showMoreBtn").forEach((el)=>{
    el.addEventListener("click", ()=>{
        const testimonialContent = el.parentElement.parentElement;
        testimonialContent.querySelector('[data-element="testimonial-text-all"]').style.display = "inline";
        testimonialContent.querySelector('[data-element="testimonial-text-less"]').style.display = "none";
    });
});
document.querySelectorAll(".testimonial-content .showLessBtn").forEach((el)=>{
    el.addEventListener("click", ()=>{
        const testimonialContent = el.parentElement.parentElement;
        testimonialContent.querySelector('[data-element="testimonial-text-all"]').style.display = "none";
        testimonialContent.querySelector('[data-element="testimonial-text-less"]').style.display = "inline";
    });
});

});
parcelRegister("8Ay3m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $640c19c59862cd3c$export$2e2bcd8739ae039; });




























const $640c19c59862cd3c$var$testimonials = [
    {
        name: "Neo Christodoulou",
        photo: {
            mobile: new URL((parcelRequire("zpPAZ"))),
            tablet: new URL((parcelRequire("jRoHP"))),
            desktop: new URL((parcelRequire("jRoHP")))
        },
        position: "Founder, Smashing Plates",
        companyLogo: new URL((parcelRequire("3e6aI"))),
        companyLogoClass: "smashing-plates",
        testimonyText: "Wenodo have been a long-standing close partner. Their holistic approach in managing our accounts has been invaluable to our organization. Not only do they handle all of our accounting needs, but they also expertly manage our HR/payroll department and also their customized cloud-based real-time analytics and reports has provided us with valuable insights and data-driven decision-making."
    },
    {
        name: "Johnny Smith and Daniel Willis",
        photo: {
            mobile: new URL((parcelRequire("cdfJc"))),
            tablet: new URL((parcelRequire("krtse"))),
            desktop: new URL((parcelRequire("krtse")))
        },
        position: "Co Founder, Luca Restaurant",
        companyLogo: new URL((parcelRequire("k2naI"))),
        companyLogoClass: "luca",
        testimonyText: "Wenodo's team is exceptional! Their profound knowledge of the hospitality industry and their friendly customer service have been invaluable to our business. Their expertise in the intricacies of our industry coupled with their approachable and supportive service have made working with them a true pleasure. They understand our needs and offer tailored solutions, making a significant difference in our operations."
    },
    {
        name: "Wonchul Park",
        photo: {
            mobile: new URL((parcelRequire("kYUk1"))),
            tablet: new URL((parcelRequire("b7fjO"))),
            desktop: new URL((parcelRequire("b7fjO")))
        },
        position: "Michelin Star Chef, Sollip",
        companyLogo: new URL((parcelRequire("2BnNh"))),
        companyLogoClass: "sollip",
        testimonyText: "Wenodo have been a long-standing close partner. Their holistic approach in managing our accounts has been invaluable to our organization. Not only do they handle all of our accounting needs, but they also expertly manage our HR/payroll department and also their customized cloud-based real-time analytics and reports has provided us with valuable insights and data-driven decision-making."
    },
    {
        name: "George\xa0Kakavitsa",
        photo: {
            mobile: new URL((parcelRequire("eO5jc"))),
            tablet: new URL((parcelRequire("lsEgi"))),
            desktop: new URL((parcelRequire("lsEgi")))
        },
        position: "Assistant Restaurant Manager, L\xedo London",
        companyLogo: new URL((parcelRequire("abrNu"))),
        companyLogoClass: "lio",
        testimonyText: "Wenodo's HR/Rota SaaS solution has revolutionized our workforce management. Its intuitive interface simplifies employee's lifecycle, shift scheduling and communication. With robust reporting, we gain valuable insights for informed decisions. Exceptional customer support ensures smooth operations. It's a game-changer for our Restaurant operation, enhancing efficiency and employee engagement. Highly recommended!"
    },
    {
        name: "Dominic Hamdy",
        photo: {
            mobile: new URL((parcelRequire("3Nu88"))),
            tablet: new URL((parcelRequire("9RA8A"))),
            desktop: new URL((parcelRequire("9RA8A")))
        },
        position: "Founder, HAM Restaurants",
        companyLogo: new URL((parcelRequire("PAMjz"))),
        companyLogoClass: "ham",
        testimonyText: "WENODO has helped to grow and streamline our business from day one. We can now make financial and strategic decisions based on data we can trust. Their personal attitude and enthusiasm to go the extra mile is invaluable, but it's their modern approach to accounting that has \xa0propelled us forward.\xa0"
    },
    // {
    //   name: 'Tarek Farah',
    //   photo: {
    //     mobile: new URL('../image/testimonial-tarek-farah-mobile.png?as=webp', import.meta.url),
    //     tablet: new URL('../image/testimonial-tarek-farah.png?as=webp', import.meta.url),
    //     desktop: new URL('../image/testimonial-tarek-farah.png?as=webp', import.meta.url)
    //   },
    //   position: 'Founder and CEO, Aline Lebanese Kitchen',
    //   companyLogo: new URL(
    //     '../image/aline-company.png',
    //     import.meta.url
    //   ),
    //   companyLogoClass: 'aline',
    //   testimonyText: 'I have been gladly working with the Wenodo team for nearly 10 years. They are not just professional, experienced, and knowledgeable accountants but also great consultants who offer so much value and advice on all levels of hospitality. I cannot imagine any of our future projects being developed without Wenodo by our side!'
    // },
    {
        name: "David Bellaiche",
        photo: {
            mobile: new URL((parcelRequire("g5wUj"))),
            tablet: new URL((parcelRequire("6INPv"))),
            desktop: new URL((parcelRequire("6INPv")))
        },
        position: "Co-Founder, NAC London",
        companyLogo: new URL((parcelRequire("36VBP"))),
        companyLogoClass: "nac",
        testimonyText: "Wenodo's daily, weekly, and monthly KPIs and analytics has been so critical for our business. Their insightful Dashboard and reports have allowed us to maximize profits. With these detailed metrics, we're empowered to make timely and informed decisions, contributing significantly to\xa0our\xa0success."
    },
    {
        name: "Gabriel Cohen-Elia",
        photo: {
            mobile: new URL((parcelRequire("lcqCb"))),
            tablet: new URL((parcelRequire("esdGk"))),
            desktop: new URL((parcelRequire("esdGk")))
        },
        position: "Co-Founder, Cr\xe8me London",
        companyLogo: new URL((parcelRequire("fBx0T"))),
        companyLogoClass: "creme",
        testimonyText: "Partnering with Wenodo has revolutionized how we manage our finances and operations. Their specialized accounting and bookkeeping solutions have not only streamlined our processes but also brought unparalleled clarity to our financial landscape. Wenodo's dedicated support team is always responsive and knowledgeable, making them an integral part of our success. For anyone in hospitality seeking reliability and expertise, Wenodo is the\xa0clear\xa0choice."
    }
];
var $640c19c59862cd3c$export$2e2bcd8739ae039 = $640c19c59862cd3c$var$testimonials;

});
parcelRegister("zpPAZ", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimoni-neo-mobile.63e4b5d3.webp";

});

parcelRegister("jRoHP", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimoni-neo.dcffeccd.webp";

});

parcelRegister("3e6aI", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "smashing-plates.7136aa41.webp";

});

parcelRegister("cdfJc", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimoni-johny-mobile.dfee8b00.webp";

});

parcelRegister("krtse", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimoni-johny.331dada6.webp";

});

parcelRegister("k2naI", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "luca-company.ebbca258.webp";

});

parcelRegister("kYUk1", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimonial-wonchul-mobile.82623782.webp";

});

parcelRegister("b7fjO", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimonial-wonchul.e435ed72.webp";

});

parcelRegister("2BnNh", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "sollip-company.c4e68d8a.png";

});

parcelRegister("eO5jc", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimonial-george-mobile.ba4357c1.webp";

});

parcelRegister("lsEgi", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimonial-george.3f5b8295.webp";

});

parcelRegister("abrNu", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "lio-company.51d21251.png";

});

parcelRegister("3Nu88", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimonial-dominic-hamdy-mobile.795bc261.webp";

});

parcelRegister("9RA8A", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimonial-dominic-hamdy.7a029c2b.webp";

});

parcelRegister("PAMjz", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "ham-company.5f8ce858.png";

});

parcelRegister("g5wUj", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimonial-david-bellaiche-mobile.c3669d3d.webp";

});

parcelRegister("6INPv", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimonial-david-bellaiche.e487dcaf.webp";

});

parcelRegister("36VBP", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "nac-company.269e0029.png";

});

parcelRegister("lcqCb", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimonial-gabriel-mobile.45a97971.webp";

});

parcelRegister("esdGk", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "testimonial-gabriel.ad41ee07.webp";

});

parcelRegister("fBx0T", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("hVU77") + "creme-company.ca71e074.png";

});



parcelRegister("2SvjK", function(module, exports) {
const $2188eaecfbdd828c$var$preferencePrivacyPopupEl = document.querySelector(".preferencePrivacy-popup");
const $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl = document.querySelector(".preferencePrivacy-popupDetail");
const $2188eaecfbdd828c$var$isCookies = document.cookie.split(";").filter((value)=>value === "_cookies=guest")[0] === "_cookies=guest" || document.cookie.split(";").filter((value)=>value === " _cookies=guest")[0] === " _cookies=guest";
if ($2188eaecfbdd828c$var$isCookies) $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
else $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// Cookies Button
document.querySelector(".btn-cookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// document.querySelector('.cookies-alert-popup').style.display = 'block'
});
document.querySelector(".cookies-accept-btn").addEventListener("click", ()=>{
    // document.querySelector('.cookies-alert-popup').style.display = 'none'
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.preferencePrivacy-popup--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.add("show");
// document.cookie = '_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC'
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
document.querySelector(".btn.cookies-learn-more-btn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
    document.querySelector(".cookies-alert-popup").style.display = "none";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.preferencePrivacy-popupDetail--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--preferencePrivacy-popupDetailConfirmPreference").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});

});

var $0ff5bcedb8f84620$exports = {};


(parcelRequire("d8HMG")).register((parcelRequire("3VV9c")).getBundleURL("hVU77"), JSON.parse('["hVU77","index.49385f7e.js","giQtv","battery-charging.ba1b1745.webp","23FFC","settings-02.d69d69bd.webp","eQ5EQ","life-buoy.285e728c.webp","1BQWm","people.d532b8d6.webp","eSkdY","grid.f0e29351.webp","9Glg9","box.2a34708a.webp","8XsBo","testimoni-neo-mobile.63e4b5d3.webp","4ho8f","testimoni-neo.dcffeccd.webp","hLnjK","smashing-plates.7136aa41.webp","lORrT","testimoni-johny-mobile.dfee8b00.webp","5pWvc","testimoni-johny.331dada6.webp","e7lNY","luca-company.ebbca258.webp","cDWBZ","testimonial-wonchul-mobile.82623782.webp","3V7nb","testimonial-wonchul.e435ed72.webp","jp2ug","sollip-company.c4e68d8a.png","3v0AM","testimonial-george-mobile.ba4357c1.webp","991Ub","testimonial-george.3f5b8295.webp","3ZUyT","lio-company.51d21251.png","cqGH0","testimonial-dominic-hamdy-mobile.795bc261.webp","3WiP9","testimonial-dominic-hamdy.7a029c2b.webp","eba0Q","ham-company.5f8ce858.png","e5FYN","testimonial-david-bellaiche-mobile.c3669d3d.webp","iQoFg","testimonial-david-bellaiche.e487dcaf.webp","isBg7","nac-company.269e0029.png","7yGuJ","testimonial-gabriel-mobile.45a97971.webp","774bJ","testimonial-gabriel.ad41ee07.webp","tTeKh","creme-company.ca71e074.png"]'));

parcelRequire("bo64b");
parcelRequire("dUzBg");
parcelRequire("5iqNH");
parcelRequire("2SvjK");
/* eslint-disable no-undef */ // import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs'
const $16f52dd416672943$var$rectangleBottomBorderTransformBusiness = `<svg
class="transformBusiness__rectangle-bottom"
width="100%"
height="auto"
viewBox="0 0 1440 54"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<path d="M1440 1L0 53" stroke="#E2E8F0" />
</svg>`;
document.querySelector(".transformBusiness").innerHTML += $16f52dd416672943$var$rectangleBottomBorderTransformBusiness;
const $16f52dd416672943$var$rectangleBottomTestimonial = `<svg class="testimonial__bg-rectangle-bottom" width="100%" height="100%" viewBox="0 0 1440 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_2239_14618" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1440" height="52">
  <path d="M1440 52L0 51.9999L1440 0L1440 52Z" fill="#1E2432" />
</mask>
<g mask="url(#mask0_2239_14618)">
  <rect x="-9" width="1458" height="879" fill="white" />
</g>
</svg>`;
document.querySelector(".section__testimonial").innerHTML += $16f52dd416672943$var$rectangleBottomTestimonial;
const $16f52dd416672943$var$arrowUpRightIcon = `<svg
width="20"
height="20"
viewBox="0 0 20 20"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<path
  d="M5.8335 14.1666L14.1668 5.83325M14.1668 5.83325H5.8335M14.1668 5.83325V14.1666"
  stroke="#05A6F0"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
/>
</svg>`;
document.querySelectorAll(".btn-talk-us").forEach((el)=>{
    el.innerHTML += $16f52dd416672943$var$arrowUpRightIcon;
    el.setAttribute("onclick", "location.href = 'contact-us.html';");
});
document.querySelectorAll(".btn-cta-product").forEach((el)=>{
    el.innerHTML += $16f52dd416672943$var$arrowUpRightIcon;
});
document.querySelectorAll(".btn-product-growth").forEach((el)=>{
    el.innerHTML += $16f52dd416672943$var$arrowUpRightIcon;
});
document.querySelector(".btn-product-testimonial").innerHTML += $16f52dd416672943$var$arrowUpRightIcon;
document.querySelector(".btn-product-about-us").innerHTML += $16f52dd416672943$var$arrowUpRightIcon;
document.querySelector(".btn-see-all-product").innerHTML += $16f52dd416672943$var$arrowUpRightIcon;
// document.querySelector('.btn-learn-more').innerHTML += arrowUpRightIcon
document.querySelector(".btn-book-demo__home").innerHTML += $16f52dd416672943$var$arrowUpRightIcon;
document.querySelectorAll(".information-map__contact-btn").forEach((el)=>{
    el.innerHTML += $16f52dd416672943$var$arrowUpRightIcon;
});
const $16f52dd416672943$var$preHeadingServiceIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="#1DCA5D" />
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8332 14.2284C13.2709 13.8584 14.3332 12.5533 14.3332 11.0001C14.3332 9.15913 12.8408 7.66675 10.9998 7.66675C9.15889 7.66675 7.6665 9.15913 7.6665 11.0001C7.6665 12.5533 8.72881 13.8584 10.1665 14.2284V23.5001C10.1665 23.9603 10.5396 24.3334 10.9998 24.3334C11.4601 24.3334 11.8332 23.9603 11.8332 23.5001V14.2284Z" fill="white" />
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6665 21.0001C17.6665 19.4469 18.7288 18.1418 20.1665 17.7718V12.6667C20.1665 12.4457 20.0787 12.2338 19.9224 12.0775C19.7661 11.9212 19.5542 11.8334 19.3332 11.8334H16.8332C16.3729 11.8334 15.9998 11.4603 15.9998 11.0001C15.9998 10.5398 16.3729 10.1667 16.8332 10.1667H19.3332C19.9962 10.1667 20.6321 10.4301 21.1009 10.899C21.5698 11.3678 21.8332 12.0037 21.8332 12.6667V17.7718C23.2709 18.1418 24.3332 19.4469 24.3332 21.0001C24.3332 22.841 22.8408 24.3334 20.9998 24.3334C19.1589 24.3334 17.6665 22.841 17.6665 21.0001Z" fill="white" />
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21.0001C17.6667 19.4469 18.729 18.1418 20.1667 17.7718V12.6667C20.1667 12.4457 20.0789 12.2338 19.9226 12.0775C19.7663 11.9212 19.5543 11.8334 19.3333 11.8334H16.8333C16.3731 11.8334 16 11.4603 16 11.0001C16 10.5398 16.3731 10.1667 16.8333 10.1667H19.3333C19.9964 10.1667 20.6323 10.4301 21.1011 10.899C21.5699 11.3678 21.8333 12.0037 21.8333 12.6667V17.7718C23.271 18.1418 24.3333 19.4469 24.3333 21.0001C24.3333 22.841 22.8409 24.3334 21 24.3334C19.1591 24.3334 17.6667 22.841 17.6667 21.0001Z" fill="#77DF9E" />
</svg>`;
document.querySelectorAll(".services__preHeading .services__icon").forEach((el)=>{
    el.innerHTML += $16f52dd416672943$var$preHeadingServiceIcon;
});
document.querySelector(".transformBusiness__preHeading-icon").innerHTML += $16f52dd416672943$var$preHeadingServiceIcon;
document.querySelector(".product__preHeading .services__icon").innerHTML += $16f52dd416672943$var$preHeadingServiceIcon;
document.querySelector(".testimonial-slider-preHeading .services__icon").innerHTML += $16f52dd416672943$var$preHeadingServiceIcon;
document.querySelector(".seamless-integration__preHeading .preHeadingIcon").innerHTML += $16f52dd416672943$var$preHeadingServiceIcon;
const $16f52dd416672943$var$servicesListItemIcon = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.6668 3.5L5.25016 9.91667L2.3335 7" stroke="#1E2432" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
document.querySelectorAll(".services__list-item-icon").forEach((el)=>{
    el.innerHTML += $16f52dd416672943$var$servicesListItemIcon;
});
const $16f52dd416672943$var$customerStoryContentBg = `<svg width="100%" height="100%" viewBox="0 0 996 237" fill="none" class="customer-story__content-bg large" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
  <path d="M0 51.5277C0 45.0877 5.08356 39.7958 11.5185 39.5374L996 0V237H0V51.5277Z" fill="#1E2432"/>
</svg>`;
const $16f52dd416672943$var$customStoryContentBgMobile = `<svg width="100%" height="100%" viewBox="0 0 327 316" fill="none" class="customer-story__content-bg small" xmlns="http://www.w3.org/2000/svg">
<path d="M0 19.801L327 0V316H0V19.801Z" fill="#1E2432"/>
</svg>
`;
document.querySelector(".js-customer-story__content-bg").innerHTML += $16f52dd416672943$var$customerStoryContentBg;
document.querySelector(".js-customer-story__content-bg").innerHTML += $16f52dd416672943$var$customStoryContentBgMobile;
const $16f52dd416672943$var$customerStoryContentQuote = `<svg class="customer-story-content-quote" width="129" height="106" viewBox="0 0 129 106" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M31.5528 100.408L33.082 101.603C39.642 96.4754 45.6415 87.5784 50.1383 77.3158C54.6425 67.0361 57.6861 55.2798 58.2597 44.3428C58.8321 33.4304 56.9513 23.1835 51.4305 16.0776C45.8535 8.89921 36.7219 5.12449 23.291 6.87312C9.97101 8.60731 -1.20758 22.1227 1.90096 35.9014C3.42636 42.6629 6.73531 47.897 11.486 51.2858C16.1257 54.5953 22.053 56.0827 28.8403 55.6095C31.3989 58.2953 34.8558 62.8601 36.3839 69.829C37.976 77.0894 37.4988 87.0709 31.5528 100.408ZM86.1274 99.006L87.4636 100.416C94.7392 96.2706 102.223 88.0993 108.521 78.2625C114.831 68.4075 120.017 56.7779 122.639 45.6107C125.253 34.4726 125.353 23.637 121.282 15.4907C117.16 7.24188 108.883 1.97667 95.3218 1.8041C81.8971 1.63326 68.7638 13.4199 69.695 27.4942C70.1522 34.4039 72.6092 40.0582 76.7811 44.0904C80.8527 48.0255 86.477 50.3378 93.2507 50.8332C97.3181 56.9567 101.697 74.7873 86.1274 99.006Z" fill="#F3A515" stroke="white" stroke-width="2"/>
</svg>`;
document.querySelector(".js-customer-story-content-quote").innerHTML += $16f52dd416672943$var$customerStoryContentQuote;
const $16f52dd416672943$var$chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".link-item .arrow-down").forEach((el)=>{
    el.innerHTML += $16f52dd416672943$var$chevronDownIcon;
});
const $16f52dd416672943$var$hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelector(".btn-hamburger").innerHTML += $16f52dd416672943$var$hamburgerIcon;
const $16f52dd416672943$var$rectangleBottomProductGrowth = `<svg width="100%" height="auto" viewBox="0 0 1440 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1440 52L0 51.9999L1440 0L1440 52Z" fill="white"/>
</svg>`;
document.querySelector(".rectangleBottonProductGrow").innerHTML += $16f52dd416672943$var$rectangleBottomProductGrowth;
const $16f52dd416672943$var$rectangleTopFinancialExpert = `<svg width="100%" height="auto" viewBox="0 0 1440 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0H1440L0 52V0Z" fill="white"/>
</svg>
`;
document.querySelector(".financial-feature-section__rectangle-top").innerHTML += $16f52dd416672943$var$rectangleTopFinancialExpert;
const $16f52dd416672943$var$featureSectionEl = document.querySelector(".feature-section");
$16f52dd416672943$var$featureSectionEl.querySelectorAll(".tab-feature").forEach((tabElement)=>{
    tabElement.addEventListener("click", ()=>{
        $16f52dd416672943$var$featureSectionEl.querySelectorAll(".tab-feature").forEach((el)=>{
            el.classList.remove("active");
        });
        $16f52dd416672943$var$featureSectionEl.querySelectorAll(".features__illustration img").forEach((el)=>{
            el.style.display = "none";
            if (tabElement.getAttribute("data-tab") === el.getAttribute("data-tab")) el.style.display = "block";
        });
        $16f52dd416672943$var$featureSectionEl.querySelectorAll(".feature-points").forEach((el)=>{
            el.style.display = "none";
            if (tabElement.getAttribute("data-tab") === el.getAttribute("data-tab")) el.style.display = "grid";
        });
        console.log(tabElement.getAttribute("data-tab"));
        tabElement.classList.add("active");
    });
});
const $16f52dd416672943$var$featurePointsDigitalTransformation = $16f52dd416672943$var$featureSectionEl.querySelector('.feature-points[data-tab="digital-transformation"]').cloneNode(true);
$16f52dd416672943$var$featureSectionEl.querySelector('.select-group-feature[data-tab="digital-transformation"]').querySelector(".feature-points-mobile").appendChild($16f52dd416672943$var$featurePointsDigitalTransformation);
const $16f52dd416672943$var$featurePointsIntelligentFinance = $16f52dd416672943$var$featureSectionEl.querySelector('.feature-points[data-tab="intelligent-finance"]').cloneNode(true);
$16f52dd416672943$var$featureSectionEl.querySelector('.select-group-feature[data-tab="intelligent-finance"]').querySelector(".feature-points-mobile").appendChild($16f52dd416672943$var$featurePointsIntelligentFinance);
const $16f52dd416672943$var$featurePointsPeopleManagement = $16f52dd416672943$var$featureSectionEl.querySelector('.feature-points[data-tab="people-management"]').cloneNode(true);
$16f52dd416672943$var$featureSectionEl.querySelector('.select-group-feature[data-tab="people-management"]').querySelector(".feature-points-mobile").appendChild($16f52dd416672943$var$featurePointsPeopleManagement);
const $16f52dd416672943$var$featurePointsAnalytics = $16f52dd416672943$var$featureSectionEl.querySelector('.feature-points[data-tab="analytics"]').cloneNode(true);
$16f52dd416672943$var$featureSectionEl.querySelector('.select-group-feature[data-tab="analytics"]').querySelector(".feature-points-mobile").appendChild($16f52dd416672943$var$featurePointsAnalytics);
$16f52dd416672943$var$featureSectionEl.querySelectorAll(".select-group-feature").forEach((selectElement)=>{
    selectElement.addEventListener("click", ()=>{
        if (selectElement.classList.contains("active")) {
            selectElement.classList.remove("active");
            selectElement.querySelector(".select-feature-content").style.display = "none";
            selectElement.querySelector(".feature-points").style.display = "none";
        } else {
            $16f52dd416672943$var$featureSectionEl.querySelectorAll(".select-group-feature").forEach((el)=>{
                el.querySelector(".select-feature-content").style.display = "none";
                el.classList.remove("active");
            });
            selectElement.classList.add("active");
            selectElement.querySelector(".select-feature-content").style.display = "block";
            selectElement.querySelector(".feature-points").style.display = "grid";
        }
    });
});
// Create the observer like the examples above
const $16f52dd416672943$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) entry.target.classList.add("animate__fadeInUp");
    // entry.target.classList.remove('animate__animated')
    });
});
// Get multiple elements instead of a single one using "querySelectorAll"
const $16f52dd416672943$var$squares = document.querySelectorAll(".animated-js");
// Loop over the elements and add each one to the observer
$16f52dd416672943$var$squares.forEach((element)=>$16f52dd416672943$var$observer.observe(element));
// eslint-disable-next-line no-unused-vars
const $16f52dd416672943$var$swiper = new Swiper(".swiper-testimonial", {
    // Optional parameters
    // direction: 'vertical',
    loop: false,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 32,
    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination'
    // },
    // Navigation arrows
    navigation: {
        nextEl: ".swiper-testimonial-next-button",
        prevEl: ".swiper-testimonial-prev-button"
    },
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar'
    // }
    breakpoints: {
        1200: {
            slidesPerView: 1.2
        }
    }
});
// eslint-disable-next-line no-unused-vars
const $16f52dd416672943$var$swiperSeamlessIntegration = new Swiper(".swiperSeamlessIntegration", {
    loop: true,
    spaceBetween: 300,
    navigation: {
        nextEl: ".swiper-seamless-integration-button-next",
        prevEl: ".swiper-seamless-integration-button-prev"
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    }
});
// eslint-disable-next-line no-unused-vars
const $16f52dd416672943$var$swiperClientLogos = new Swiper(".swiper-client-logos", {
    loop: true,
    autoplay: true
});
const $16f52dd416672943$var$isLarge = window.matchMedia("(min-width: 1200px)");
if ($16f52dd416672943$var$isLarge.matches) // Then trigger an alert
$16f52dd416672943$var$swiper.on("slideChange", function() {
    if ($16f52dd416672943$var$swiper.activeIndex === 0) document.querySelector(".swiper-wrapper.testimonial-cards").style.left = "-8.25%";
    else if ($16f52dd416672943$var$swiper.activeIndex === 1) {
        document.querySelector(".swiper-wrapper.testimonial-cards").style.left = "auto";
        document.querySelector(".swiper-wrapper.testimonial-cards").style.right = "auto";
    } else if ($16f52dd416672943$var$swiper.activeIndex === 2) document.querySelector(".swiper-wrapper.testimonial-cards").style.right = "-8.25%";
});

})();
//# sourceMappingURL=index.49385f7e.js.map
